import { render, staticRenderFns } from "./PermissionsForm.vue?vue&type=template&id=603e792e&scoped=true"
import script from "./PermissionsForm.vue?vue&type=script&lang=js"
export * from "./PermissionsForm.vue?vue&type=script&lang=js"
import style0 from "./PermissionsForm.vue?vue&type=style&index=0&id=603e792e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603e792e",
  null
  
)

export default component.exports